"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultValidator = exports.KnotchGraphContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _knotchincWebReactComponentsGraphs = _interopRequireDefault(require("@bit/knotchinc.web-react-components.graphs.graph-error"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  min-Width: 100px;\n  text-align: center;\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var KnotchGraphContainer = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      pctWidth = _ref.pctWidth;
  return pctWidth && theme.graphSizes ? theme.graphSizes[pctWidth] : '95%';
});

exports.KnotchGraphContainer = KnotchGraphContainer;

var defaultValidator = function defaultValidator(args) {
  var _args$data = args.data,
      data = _args$data === void 0 ? [] : _args$data,
      _args$unit = args.unit,
      unit = _args$unit === void 0 ? 'value' : _args$unit;
  return Object.keys(data).length > 0 && data.find(function (d) {
    return d[unit] !== 0;
  });
};

exports.defaultValidator = defaultValidator;

var KnotchGraph = function KnotchGraph(props) {
  var _props$validate = props.validate,
      validate = _props$validate === void 0 ? defaultValidator : _props$validate,
      children = props.children,
      height = props.height,
      pctWidth = props.pctWidth;

  if (validate(props)) {
    return _react["default"].createElement(KnotchGraphContainer, {
      pctWidth: pctWidth
    }, children);
  } // Invalid data render


  return _react["default"].createElement(KnotchGraphContainer, {
    pctWidth: pctWidth
  }, _react["default"].createElement(_knotchincWebReactComponentsGraphs["default"], {
    noData: true,
    height: height
  }));
};

var _default = KnotchGraph;
exports["default"] = _default;

//# sourceMappingURL=KnotchGraph.js.map